<template>
  <div class="exam-download">
    <div class="exam-download-button">
      <button
        class="exam-download__btn-open btn btn-primary"
        @click="downloadExams()"
      >
        <svg-loader
          src="/static/images/icon-download-arrow.svg"
          class=""
        />
        Exportar todos os exames
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Download',
  methods: {
    downloadExams () {
      window.open(`${process.env.BASE_URL_API}exams-guide/v1/spreadsheet`)
    }
  }
}
</script>
<style lang="scss">
.exam-download {
  display: flex;
  position: relative;
  z-index: 1000;

  &__box-button {
    width: 27%;
  }

  &__btn-open {
    width: 232px;
    height: 32px;
    font-family: 'Exo 2';
    text-transform: uppercase;
    display: flex;
    align-items: center;
    padding: 0 15px;
    background: #fff;
    color: #7f1a54;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 2px rgba(129, 129, 129, 0.3);
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;

    &:hover {
      background: #F2F2F2 !important;
    }

    .md-icon {
      margin: 0;
      margin-right: 7px;
      min-width: 15px;
      width: 27px;

      svg path {
        fill: #7F1A54;
      }
    }
  }
}
</style>
